/** Texts of the projects pages (en), below `projects.projectPages`. */
export const projectPages = {
  fields: {
    number: 'Number',
    title: 'Title',
    type: 'Project type',
    description: 'Description',
    client: 'Client',
    clientContact: 'Contact person',
    object: 'Object',
    status: 'Status',
    lead: 'Project lead',
    period: 'Period',
    orderedOn: 'Order date',
    startsOn: 'Start',
    endsOn: 'Planned end',
    contractEnd: 'End of contract',
  },
  list: {
    title: 'Projects',
    description: 'Projects of the company with client, object and status.',
    new: 'New project',
    objectAndMore_one: '{{name}} and {{count}} more object',
    objectAndMore_other: '{{name}} and {{count}} more objects',
    search: 'Search projects',
    searchPlaceholder: 'Number, title, client …',
    allStatuses: 'All statuses',
    allTypes: 'All project types',
    mine: 'Mine only',
    archive: 'Archive',
    current: 'Current',
    archived: 'Archived',
    period: '{{from}} – {{to}}',
    exportName: 'Projects',
    empty: 'No projects yet',
    emptyHint: 'Create the first project with “New project”.',
    emptyReadOnly: 'Projects whose team you are in show up here.',
    noMatches: 'No matching projects',
    noMatchesHint: 'Change the search or filters.',
  },
  form: {
    createTitle: 'New project',
    editTitle: 'Edit project',
    more: 'More details',
    chooseType: 'Choose a project type',
    noTypes: 'No project types yet',
    noTypesHint: 'A project needs a project type. Please ask whoever manages projects.',
    setUpTypes: 'Set up project types',
    numberHint: 'The company assigns project numbers by hand.',
    contactHint: 'Choose the client first.',
    objectHint: 'Building or property of the project. Add more objects on the project page.',
    created: 'Project {{number}} created',
    updated: 'Project saved',
    reload: 'Reload',
    conflictHint: 'Reloading shows the current state; your changes will be lost.',
  },
  detail: {
    masterData: 'Details',
    changed: 'changed {{when}}',
    notFound: 'Project not found',
    notFoundHint: 'It may have been deleted, or you are not in its team.',
    archive: 'Archive',
    archiveTitle: 'Archive project?',
    archiveDescription:
      'Project {{number}} disappears from the list and pickers. It stays in the archive and can be restored.',
    archivedToast: 'Project archived',
    archivedTitle: 'Archived',
    archivedSince: 'since {{when}}',
    restore: 'Restore',
    restored: 'Project restored',
    deleteTitle: 'Delete project?',
    deleteDescription:
      'Project {{number}} is deleted with its team, parties, services, files and comments. This cannot be undone.',
    deleted: 'Project {{number}} deleted',
  },
  team: {
    title: 'Team',
    hint: 'People of the company working on the project. With scope “Team”, only they see the project.',
    person: 'Person',
    role: 'Role',
    roleOf: 'Role of {{name}}',
    addMe: 'Add me',
    add: 'Add person',
    added: 'Added to the team',
    roleChanged: 'Role changed',
    removeFrom: 'Remove {{name}} from the team',
    removeTitle: 'Remove from the team?',
    removeDescription:
      '{{name}} will no longer be in the team. With scope “Team”, the project is then hidden from them.',
    removed: 'Removed from the team',
    empty: 'Nobody in the team yet',
    emptyHint: 'Bring colleagues into the team with “Add person”.',
    emptyReadOnly: 'The team of the project shows up here.',
  },
  memberRoles: {
    lead: 'Project lead',
    deputy: 'Deputy',
    engineer: 'Engineer',
    drafter: 'Drafter',
    'site-supervisor': 'Site supervisor',
    assistant: 'Assistant',
    other: 'Other',
  },
  objects: {
    title: 'Objects',
    hint: 'Buildings and properties the project covers.',
    count_one: '{{count}} object',
    count_other: '{{count}} objects',
    name: 'Object',
    city: 'City',
    create: 'New object',
    add: 'Assign existing object',
    added: 'Object assigned',
    removeFrom: 'Remove {{name}} from the project',
    removeTitle: 'Remove object from the project?',
    removeDescription: '{{name}} will no longer belong to the project. The object itself stays.',
    removed: 'Object removed',
    empty: 'No object yet',
    emptyHint:
      'Create a building with “New object” or pick one from earlier projects with “Assign existing object”, e.g. all schools of a school authority.',
    emptyReadOnly: 'The objects of the project show up here.',
  },
  participants: {
    title: 'Parties',
    hint: 'Organisations outside the company, e.g. architect, checking engineer, building authority.',
    add: 'Add party',
    addTitle: 'Add party',
    editTitle: 'Edit party',
    organization: 'Organisation',
    contact: 'Contact person',
    role: 'Role',
    note: 'Note',
    actions: 'Actions for the party',
    added: 'Party added',
    updated: 'Party saved',
    removeTitle: 'Remove party?',
    removeDescription: 'The organisation stays in Customers; only its entry on the project goes.',
    removed: 'Party removed',
    empty: 'No parties yet',
    emptyHint: 'Add architects, specialist planners or authorities with “Add party”.',
    emptyReadOnly: 'External parties of the project show up here.',
  },
  distribution: {
    title: 'Distribution lists',
    hint: 'Who gets mails about the project, e.g. the minutes of site meetings. All addresses copy at once into the address line of Outlook.',
    new: 'New distribution list',
    newTitle: 'New distribution list',
    renameTitle: 'Rename distribution list',
    rename: 'Rename',
    created: 'Distribution list created',
    renamed: 'Distribution list renamed',
    actions: 'Actions for {{name}}',
    count_one: '1 recipient',
    count_other: '{{count}} recipients',
    empty: 'No distribution lists yet',
    emptyHint: 'Use “New distribution list” to create e.g. a list “Minutes”.',
    emptyReadOnly: 'Distribution lists of the project show up here.',
    notFound: 'Distribution list not found. Reload the page.',
    fields: {
      listName: 'Name',
      listNameHint: 'For example minutes or invoices.',
      name: 'Name',
      email: 'Email address',
      state: 'Source',
    },
    source: { contact: 'Contact person', address: 'Pasted' },
    missing: {
      unavailable: 'Unavailable',
      left: 'Left',
      'no-email': 'No address',
    },
    addContact: 'Add contact person',
    paste: 'Paste from Outlook',
    pasteTitle: 'Paste addresses into “{{name}}”',
    pasteLabel: 'Addresses',
    pasteHint:
      'In Outlook, select the recipients in the address line, copy them and paste them here. Plain lists separated by semicolons, commas or line breaks work too.',
    recognised_one: '1 address recognised',
    recognised_other: '{{count}} addresses recognised',
    invalid_one: '1 entry is not a valid address and is left out',
    invalid_other: '{{count}} entries are not valid addresses and are left out',
    pasteConfirm_one: 'Add 1 address',
    pasteConfirm_other: 'Add {{count}} addresses',
    pasted_one: '1 recipient added',
    pasted_other: '{{count}} recipients added',
    copy: 'Copy addresses',
    copied_one: '1 address copied',
    copied_other: '{{count}} addresses copied',
    copiedHint: 'Paste them into the To, Cc or Bcc line in Outlook.',
    copyFailed: 'Copying did not work. Please try again.',
    skipped_one: '1 recipient without an address is not copied',
    skipped_other: '{{count}} recipients without an address are not copied',
    noRecipients: 'No recipients yet',
    noRecipientsHint: 'Choose contact persons or paste addresses from Outlook.',
    noRecipientsReadOnly: 'Recipients of the list show up here.',
    removeRecipient: 'Remove {{name}} from the list',
    removeTitle: 'Delete distribution list?',
    removeDescription:
      '“{{name}}” is deleted with all recipients. The contact persons in Customers stay.',
    removed: 'Distribution list deleted',
  },
  participantRoles: {
    client: 'Building owner',
    architect: 'Architect',
    'structural-engineer': 'Structural engineering',
    'specialist-planner': 'Specialist planning',
    'test-engineer': 'Checking engineer',
    'building-authority': 'Building authority',
    'fire-department': 'Fire department',
    contractor: 'Contractor',
    other: 'Other',
  },
  services: {
    title: 'Services and phases',
    add: 'Add service',
    addTitle: 'Add service',
    name: 'Service',
    nameHint: 'e.g. fire protection concept or site supervision',
    template: 'Phases from template',
    templateHint: 'The phases are copied and can be changed on the project afterwards.',
    templateOption_one: '{{name}} ({{count}} phase)',
    templateOption_other: '{{name}} ({{count}} phases)',
    noTemplate: 'Without phases',
    created: 'Service created',
    rename: 'Rename',
    renameTitle: 'Rename service',
    renamed: 'Service renamed',
    statusOf: 'Status of {{name}}',
    statusChanged: 'Status of the service changed',
    actionsFor: 'Actions for {{name}}',
    phaseCount_one: '{{count}} phase',
    phaseCount_other: '{{count}} phases',
    phasesOf: 'Phases of {{name}}',
    noPhases: 'No phases. Add phases from the menu of the service.',
    phaseChanged: '{{name}}: {{status}}',
    doneOn: 'done on {{date}}',
    addPhase: 'Add phase',
    phaseCode: 'Code',
    phaseName: 'Name',
    phaseCreated: 'Phase added',
    deletePhase: 'Delete phase {{name}}',
    deletePhaseTitle: 'Delete phase?',
    deletePhaseDescription: 'The phase “{{name}}” is deleted from the service.',
    phaseDeleted: 'Phase deleted',
    deleteTitle: 'Delete service?',
    deleteDescription: 'The service “{{name}}” is deleted with all its phases.',
    deleted: 'Service deleted',
    empty: 'No services yet',
    emptyHint: 'Create a service with its phases with “Add service”.',
    emptyReadOnly: 'Services and phases of the project show up here.',
  },
  serviceStatuses: {
    offered: 'Offered',
    ordered: 'Ordered',
    active: 'In progress',
    done: 'Done',
    cancelled: 'Dropped',
  },
  phaseStatuses: {
    'not-ordered': 'Not ordered',
    ordered: 'Ordered',
    active: 'In progress',
    done: 'Done',
  },
  customer: {
    role: 'Role',
    client: 'Client',
    participant: 'Party',
    create: 'Create project',
    empty: 'No projects',
    emptyHint: 'Projects with this organisation as client or party show up here.',
  },
  tile: {
    empty: 'No running projects',
    emptyHint: 'Projects whose team you are in show up here.',
    more_one: '{{count}} running project',
    more_other: '{{count}} running projects',
  },
  picker: {
    placeholder: 'Choose a project',
    search: 'Search number or title',
    empty: 'No matching project',
    create: 'Create project',
    createNamed: 'Create “{{title}}” as project',
    loading: 'Loading …',
    unavailable: 'not available',
  },
  errors: {
    type: 'Choose a project type.',
    title: 'Enter a title.',
    number: 'Enter a project number.',
    endsBeforeStart: 'The end is before the start.',
    organization: 'Choose an organisation.',
    serviceName: 'Enter a name for the service.',
    phaseName: 'Enter a name for the phase.',
    invalid: 'Check this entry.',
    invalidInput: 'Check your entries.',
    versionConflict: 'Changed by someone else in the meantime.',
    conflict: 'Does not match the current state. Reload the page and try again.',
    notFound: 'Project not found. It may have been deleted.',
    memberNotFound: 'No longer in the team. Reload the page.',
    participantNotFound: 'Party not found. Reload the page.',
    serviceNotFound: 'Service or phase not found. Reload the page.',
    forbidden: 'You lack a permission for this.',
    rateLimited: 'Too many requests, please try again in a moment.',
  },
};
